import { useState } from "react";
import { toast } from "sonner";
import { FileText, AppWindow, Package, Braces, BookOpenCheck, Loader2 } from "lucide-react";
import { errMsg, downloadFile } from "../../../lib/api";

const CARDS = [
  { kind: "pdf", icon: FileText, title: "PDF guide", sub: "Typeset A4 premium kit", file: "kit.pdf" },
  { kind: "app", icon: AppWindow, title: "Offline toolkit", sub: "Interactive single-file HTML app", file: "kit.html", app: true },
  { kind: "bundle", icon: Package, title: "Store package", sub: "ZIP: PDF + app + listing", file: "kit.zip", app: true },
  { kind: "listing", icon: Braces, title: "Listing JSON", sub: "Product copy for the site", file: "listing.json" },
  { kind: "sample", icon: BookOpenCheck, title: "Free sample", sub: "Cover + Chapter I, watermarked", file: "sample.pdf" },
];

const Card = ({ card, kitId, dark, c, disabled }) => {
  const [busy, setBusy] = useState(false);
  const Icon = card.icon;
  const go = async () => {
    setBusy(true);
    try { await downloadFile(`/kits/${kitId}/download/${card.kind}`, card.file); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <button data-testid={`download-${card.kind}-button`} onClick={go} disabled={disabled || busy}
      className={`group text-left p-6 border-r border-stone-200 last:border-r-0 transition-colors disabled:opacity-40 ${dark ? "text-white" : "bg-white hover:bg-[#FBF9F4] text-[#2B2A26]"}`}
      style={dark ? { background: c.dark } : undefined}>
      <Icon size={20} className={dark ? "text-white/70" : "text-stone-400"} strokeWidth={1.4} />
      <div className="font-display text-xl mt-5">{card.title}</div>
      <div className={`text-xs mt-1 ${dark ? "text-white/70" : "text-stone-500"}`}>{card.sub}</div>
      <div className={`font-mono-ui text-[10px] tracking-[0.25em] uppercase mt-6 inline-flex items-center gap-2 ${dark ? "text-white/80" : "text-stone-400 group-hover:text-[#2B2A26]"}`}>
        {busy ? <><Loader2 size={11} className="animate-spin" /> Preparing</> : <>Download <span className="transition-transform group-hover:translate-x-1">→</span></>}
      </div>
    </button>
  );
};

export const DownloadCards = ({ kit, c, disabled, pdfOnly }) => {
  const cards = CARDS.filter((x) => !(pdfOnly && x.app));
  return (
    <section data-testid="download-cards" className="rise grid border border-stone-200 mb-12 overflow-x-auto" style={{ gridTemplateColumns: `repeat(${cards.length}, minmax(170px, 1fr))` }}>
      {cards.map((x, i) => <Card key={x.kind} card={x} kitId={kit.id} dark={i === 0} c={c} disabled={disabled} />)}
    </section>
  );
};
